"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const error_1 = require("../error");
class VariableManager {
    constructor(parent = null) {
        this._returnValue = undefined;
        this.variables = new Map();
        this._parent = parent;
    }
    parentSetValue(name, value, index = null) {
        if (this.variables.has(name)) {
            this.assignment(name, value, index);
            return true;
        }
        else if (this._parent) {
            return this._parent.parentSetValue(name, value, index);
        }
        return false;
    }
    assignment(name, value, index = null) {
        if (index !== null) {
            return this.setArrayElementVariable(name, value, index);
        }
        else {
            return this.setVariable(name, value);
        }
    }
    setArrayElementVariable(name, value, index) {
        if (this._parent) {
            const result = this._parent.parentSetValue(name, value, index);
            if (!result && this.variables.has(name)) {
                const array = this.variables.get(name);
                array.image[index] = value;
                this.variables.set(name, Object.assign({}, array));
            }
        }
        else {
            const array = this.variables.get(name);
            array.image[index] = value;
            this.variables.set(name, Object.assign({}, array));
        }
    }
    setVariable(name, value) {
        if (this._parent) {
            const result = this._parent.parentSetValue(name, value);
            if (!result) {
                this.variables.set(name, value);
            }
        }
        else {
            this.variables.set(name, value);
        }
    }
    reference(name, index = null) {
        if (index !== null) {
            return this.getArrayElementVariable(name, index);
        }
        else {
            return this.getVariable(name);
        }
    }
    getArrayElementVariable(name, index) {
        if (this.variables.has(name)) {
            const value = this.variables.get(name);
            if (index >= value.image.length)
                throw new error_1.OutOfRangeError(`${name}`);
            return this.variables.get(name).image[index];
        }
        const value = (this._parent !== null && this._parent.reference(name, index)) || null;
        if (value === null) {
            throw new error_1.NullReferenceVariableError(`${name}`, name);
        }
        return value;
    }
    getVariable(name) {
        if (this.variables.has(name)) {
            return this.variables.get(name);
        }
        const value = (this._parent !== null && this._parent.reference(name)) || null;
        if (value === null) {
            throw new error_1.NullReferenceVariableError(`${name}`, name);
        }
        return value;
    }
    set returnValue(value) {
        this._returnValue = value;
    }
    get returnValue() {
        return this._returnValue;
    }
    get returnExist() {
        return this._returnValue !== undefined;
    }
    debug() {
        console.group('variables');
        console.dir(this.variables, { depth: null });
        console.groupEnd();
    }
}
exports.VariableManager = VariableManager;
